if($('.type-category').length){
   function mhCatBanner(){
      if(!$('.products .bannerKat').length){
         $('#products .product:nth-child(6)').after($('footer#footer .katObr').html());
      }
      if(!$('.products .katObrBottom').length){
         $('#products .product:nth-child(13)').after($('footer#footer .katObrBottom').html());
      }
   }
   $(document).ready(function(){
      mhCatBanner();
   })
   document.addEventListener('ShoptetDOMContentLoaded', function() {
      mhCatBanner();
   }); 
   document.addEventListener('ShoptetDOMPageContentLoaded', function() {
      mhCatBanner();
   }); 
   document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
      mhCatBanner();
   }); 
}